module.exports = __webpack_public_path__ + "plugins/web/img/logo.215b4e0d.png";